// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ScrollToTop from "./components/ScrollToTop"; // Import the new component
import Header from "./components/Header";
import Hero from "./components/Hero";
import Partnerships from "./components/Partnerships";
import About from "./components/About";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import Mobile from "./components/Mobile";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import SavingsAccount from "./components/services/SavingsAccount";
import CurrentAccount from "./components/services/CurrentAccount";
import MinorAccount from "./components/services/MinorAccount";
import MicroATM from "./components/services/MicroATM";
import AEPS from "./components/services/AEPS";
import GoldLoan from "./components/services/GoldLoan";
import PersonalLoan from "./components/services/PersonalLoan";
import BusinessLoan from "./components/services/BusinessLoan";
import MerchantServices from "./components/services/MerchantServices";
import FinoDomestic from "./components/services/FinoDomestic";
import FinoInternational from "./components/services/FinoInternational";
import LifeInsurance from "./components/services/LifeInsurance";
import HealthInsurance from "./components/services/HealthInsurance";
import GeneralInsurance from "./components/services/GeneralInsurance";
import FixedDeposit from "./components/services/FixedDeposit";
import CreditCard from "./components/services/CreditCard";
import Fastag from "./components/services/Fastag";
import AtalPension from "./components/services/AtalPension";
import ServicesPage from "./components/ServicesPage";
import AboutUs from "./components/AboutUs";
import CallbackPage from "./pages/CallbackPage";

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Add this right here */}
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Partnerships />
                <About />
                <Services />
                <HowItWorks />
                <Mobile />
                <FAQ />
                <Contact />
              </>
            } />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/savings-accounts" element={<SavingsAccount />} />
            <Route path="/current-accounts" element={<CurrentAccount />} />
            <Route path="/minor-accounts" element={<MinorAccount />} />
            <Route path="/micro-atm" element={<MicroATM />} />
            <Route path="/aeps" element={<AEPS />} />
            <Route path="/gold-loans" element={<GoldLoan />} />
            <Route path="/personal-loans" element={<PersonalLoan />} />
            <Route path="/business-loans" element={<BusinessLoan />} />
            <Route path="/merchant-services" element={<MerchantServices />} />
            <Route path="/fino-domestic-money-transfer" element={<FinoDomestic />} />
            <Route path="/fino-international-money-transfer" element={<FinoInternational />} />
            <Route path="/life-insurance" element={<LifeInsurance />} />
            <Route path="/health-insurance" element={<HealthInsurance />} />
            <Route path="/general-insurance" element={<GeneralInsurance />} />
            <Route path="/fixed-deposits" element={<FixedDeposit />} />
            <Route path="/credit-card-bill-payments" element={<CreditCard />} />
            <Route path="/fastags" element={<Fastag />} />
            <Route path="/atal-pension-yojana" element={<AtalPension />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/callback" element={<CallbackPage />} />
          </Routes>
        </main>
        <Footer />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </Router>
  );
}

export default App;